export class ModReleaseFilter {
  description!: string;
  building!: string[];
  floor!: string[];
  riser!: string[];
  room!: string[];
  tag!: string[];
  unreleasedOnly!: boolean;
}
